import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'components';

const SortSelect = ({ sortBy = {}, handleFilterChange }) => {
    const { parameter, selectedValue, options } = sortBy;
    if (!options) {
        return null;
    }

    return (
        <Select
            id={parameter}
            options={options}
            selectedValue={selectedValue}
            label={'Sortering:'}
            handleChange={e => {
                handleFilterChange(parameter, e);
            }}
            classNames={'d-flex'}
        />
    );
};

SortSelect.propTypes = {
    sortBy: PropTypes.object,
    handleFilterChange: PropTypes.func
};

export default SortSelect;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/sort/sort-select.jsx